import React from 'react'
import {
  StyledBadgeContainer,
  StyledBadgeContent,
  StyledBadgeCounter,
  StyledBadgeDotIndicator,
} from './BadgePill.styles'
import type { BadgePillProps } from './BadgePill.types'

const MAX_DISPLAY_VALUE = 99

export const BadgePill = (props: BadgePillProps) => {
  const {
    children,
    dotIndicator,
    value,
    hidden,
    xOffset,
    yOffset,
    ...restProps
  } = props

  return (
    <StyledBadgeContainer>
      {children}
      <StyledBadgeContent
        {...restProps}
        $overlapping={!!children}
        $hidden={hidden}
        $xOffset={xOffset}
        $yOffset={yOffset}
      >
        {dotIndicator && <StyledBadgeDotIndicator />}
        {!dotIndicator && (
          <StyledBadgeCounter $oneDigit={value >= 0 && value < 10}>
            {value > MAX_DISPLAY_VALUE ? `${MAX_DISPLAY_VALUE}+` : value}
          </StyledBadgeCounter>
        )}
      </StyledBadgeContent>
    </StyledBadgeContainer>
  )
}
